var _svg;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAnchor = ({
  className = '',
  ...props
}) => /*#__PURE__*/React.createElement("span", _extends({
  className: `-svg-file-Anchor Icon ${className}`
}, props), _svg || (_svg = /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  viewBox: "0 0 28 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.738 16.474 15.624 26.539v-13.71h4.822V9.608h-4.822v-.286a4.796 4.796 0 0 0 3.145-5.335A4.815 4.815 0 0 0 14.017 0a4.815 4.815 0 0 0-4.752 3.987 4.796 4.796 0 0 0 3.145 5.335v.286H7.588v3.199h4.822v13.709L2.296 16.474 0 18.759l12.87 12.76a1.61 1.61 0 0 0 2.295 0L28 18.737zM14.018 3.21c.887 0 1.606.716 1.606 1.6 0 .883-.72 1.599-1.607 1.599a1.603 1.603 0 0 1-1.607-1.6c0-.883.72-1.599 1.607-1.599Z"
}))));
export default SvgAnchor;